export enum API_GATEWAY_ENDPOINTS {
  LOCAL = 'http://localhost:8080',
  DEU_DEVELOPMENT = 'https://api2.dev-weltsparen.de',
  DEU_ONBOARDING = 'https://api2.onboarding-weltsparen.de',
  DEU_PRODUCTION = 'https://api2.weltsparen.de',
  DEU_STAGING = 'https://api2.staging-weltsparen.de',

  GBR_DEVELOPMENT = 'https://api2.dev-raisin.co.uk',
  GBR_ONBOARDING = 'https://api2.onboarding-raisin.co.uk',
  GBR_PRODUCTION = 'https://api2.raisin.co.uk',
  GBR_STAGING = 'https://api2.staging-raisin.co.uk',
}

export enum MICROSERVICES_NAMES {
  DBS = 'dbs',
  OBS = 'obs',
  IS = 'wjis',
  VARIFY = 'varify',
}
